module.exports = __webpack_public_path__ + "img/product01-3.c5c4b911.png";